import * as React from 'react'
import { I18n } from 'react-redux-i18n'
import { getStaticImage } from 'utils/statics'

import DNS_URLS from '../../constants/dnsUrls'
import ModalWrapper from './ModalWrapper'
import Button from 'components/Form/Button'

const channelsOrder = ['imap', 'gmail', 'outlook', 'chatweb', 'whatsapp', 'sms', 'facebook', 'telegram', 'android', 'ios', 'wall', 'instagram']

const orderChannelsPreview = (selectedChannels) => {
  let orderedChannels = []

  for (let i = 0; i < channelsOrder.length; i++) {
    const channels = selectedChannels.filter(channel => channel.key === channelsOrder[i])

    if (channels.length) {
      if (channels[0].key === 'chatweb') {
        channels[0].isMobile
          ? orderedChannels.push(channels[0])
          : orderedChannels.unshift(channels[0])
      } else {
        orderedChannels.push(...channels)
      }
    }
  }

  return orderedChannels
}

const WebWidgetDisplay = (props) => {
  const code = `<script src="${DNS_URLS.aocsScript}" async data-aocsToken="${props.webWidgetToken}"></script>`
  const [codeCopied, setCodeCopied] = React.useState(false)
  const selectedChannels = orderChannelsPreview(props.selectedChannels)
  const position = props?.widget?.alignment || 9
  const orientation = props?.widget?.position || 'horizontal'
  const positionM = props?.widget?.alignmentMobile || 9
  const orientationM = props?.widget?.positionMobile || 'horizontal'

  const channels = (channel, index) => {
    switch (channel.key) {
      case 'imap':
      case 'gmail':
      case 'outlook':
        return (
          <div className='channel' key={index}>
            <img alt={`${channel.key}`} src={getStaticImage(`/widgets/${channel.hub}-icon.svg`)} />
          </div>
        )
      case 'chatweb':
        return (
          <div className='channel' key={index}>
            <img alt={`${channel.key}`} src={getStaticImage(`/widgets/${channel.key}-icon.svg`)} />
          </div>
        )
      case 'whatsapp':
        return (
          <div className='channel' key={index}>
            <img alt={`${channel.key}`} src={getStaticImage(`/widgets/${channel.key}-icon.svg`)} />
          </div>
        )
      case 'sms':
        return (
          <div className='channel' key={index}>
            <img alt={`${channel.key}`} src={getStaticImage(`/widgets/${channel.key}-icon.svg`)} />
          </div>
        )
      case 'facebook':
        return (
          <div className='channel' key={index}>
            <img alt={`${channel.key}`} src={getStaticImage(`/widgets/${channel.key}-icon.svg`)} />
          </div>
        )
      case 'instagram':
        return (
          <div className='channel' key={index}>
            <img alt={`${channel.key}`} src={getStaticImage(`/widgets/${channel.key}-icon.svg`)} />
          </div>
        )
      case 'telegram':
        return (
          <div className='channel' key={index}>
            <img alt={`${channel.key}`} src={getStaticImage(`/widgets/${channel.key}-icon.svg`)} />
          </div>
        )
      case 'android':
        return (
          <div className='channel' key={index}>
            <img alt={`${channel.key}`} src={getStaticImage(`/widgets/${channel.key}-icon.svg`)} />
          </div>
        )
      case 'ios':
        return (
          <div className='channel' key={index}>
            <img alt={`${channel.key}`} src={getStaticImage(`/widgets/${channel.key}-icon.svg`)} />
          </div>
        )
      case 'wall':
        if (channel.value.connectionType === 'chatweb_api') {
          return (
            <div className='channel' key={index}>
              <img alt={`${channel.value.connectionType}`} src={getStaticImage(`/widgets/${channel.key}-icon.svg`)} />
            </div>
          )
        } else if (channel.value.connectionType === 'android_api') {
          return (
            <div className='channel' key={index}>
              <img alt={`${channel.value.connectionType}`} src={getStaticImage(`/widgets/${'android'}-icon.svg`)} />
            </div>
          )
        } else {
          return (
            <div className='channel' key={index}>
              <img alt={`${channel.value.connectionType}`} src={getStaticImage(`/widgets/${'ios'}-icon.svg`)} />
            </div>
          )
        }
      default:
        return null
    }
  }

  const body = (
    <div>
      <h1>{I18n.t('channels_web_widget')}</h1>
      <div className='code-title'>{I18n.t('dashboard_preview')}</div>
      <div className='preview-container-wrapper'>
        <div className='preview-container'>
          <div className='preview-section'>
            <div className={`preview position-${position} ${orientation}`}>
              <div className='widget' style={{ backgroundColor: props.primaryColor }}>
                <img alt="" src={getStaticImage('/qr-aocs-white.svg')} />
              </div>
              {selectedChannels.map((channel, index) => channels(channel, index))}
            </div>
          </div>
        </div>
        <div className='preview-container preview-container-mobile'>
          <div className='preview-section'>
            <div className={`preview preview-mobile position-${positionM} ${orientationM}`}>
              <div className='widget' style={{ backgroundColor: props.primaryColor }}>
                <img alt="" src={getStaticImage('/qr-aocs-white.svg')} />
              </div>
              {selectedChannels.map((channel, index) => channels(channel, index))}
            </div>
          </div>
        </div>
      </div>
      <div className='code-container'>
        <div className='code-title'>{I18n.t('channels_web_widget_display_code_title')}</div>
        <div className='code-subtitle'>{I18n.t(props?.isNew ? 'channels_web_widget_display_code_subtitle' : 'channels_web_widget_display_code_subtitle_edit')}</div>
        <div className='code-editor'>{code}</div>
        <div className='displays-buttons'>
          <Button
            primary
            value={codeCopied ? I18n.t('channels_web_widget_display_code_copied') : I18n.t('channels_web_widget_display_code_copy')}
            onClick={() => {
              navigator.clipboard.writeText(code)
              setCodeCopied(true)
            }}
          />
          {!props?.isNew ? (
            <Button
              secondary
              value={I18n.t('buttons_back_edit')}
              onClick={() => {
                props.toggle()
                props.setIsOpenModalWebWidget(true)
              }}
            />
          ) : null}
        </div>
      </div>
    </div>
  )

  return (
    <ModalWrapper
      id={'modalWebWidgetDisplay'}
      header={' '}
      body={body}
      isOpen={props.isOpen}
      toggle={props.toggle}
      showClose={true}
    />
  )
}

export default WebWidgetDisplay
